import * as React from 'react';

type ISeedIconProps = React.SVGProps<SVGSVGElement>;

const SeedIcon: React.FunctionComponent<ISeedIconProps> = ({
  width = 24,
  height = 24,
  color = '#094FFE',
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 37 37'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M15.2934 19.2991C15.2934 19.2991 17.4723 13.9162 14.9169 10.0778C12.3614 6.23937 6.13833 4.75246 5.80887 4.98779C5.47942 5.22137 3.86002 10.7838 6.41549 14.6222C8.97096 18.4606 15.2934 19.2991 15.2934 19.2991ZM15.2934 19.2991C16.165 21.0423 19.0604 23.7372 19.0604 28.9667V32.453C19.0604 28.9667 18.3108 26.4931 22.6687 22.1352M22.6687 22.1352C22.6687 22.1352 21.8145 17.2736 24.621 14.5385C27.4275 11.8035 32.4478 11.8419 32.7616 12.3003C33.0753 12.7588 33.5146 17.2579 30.879 19.8273C28.0725 22.5623 22.6687 22.1352 22.6687 22.1352Z'
        stroke={color}
        strokeWidth='1.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default SeedIcon;
